export class ReglesAttributionConf {
    /**Identifiant*/
    id: number;

    /**Délai de départ train*/
    delaiDepartTrain: number;

    /**Délai de retour train*/
    delaiRetourTrain: number;

    /**Délai de départ avion*/
    delaiDepartAvion: number;

    /**Délai de retour avion*/
    delaiRetourAvion: number;

    /**Répartition avantageuse*/
    repartitionAvantageuse: boolean;

    /**Ouverture des droits*/
    ouvertureDroits: boolean;

    constructor(data?: Partial<ReglesAttributionConf>) {
        this.id = data?.id ?? 0;
        this.delaiDepartTrain = data?.delaiDepartTrain ?? 0;
        this.delaiRetourTrain = data?.delaiRetourTrain ?? 0;
        this.delaiDepartAvion = data?.delaiDepartAvion ?? 0;
        this.delaiRetourAvion = data?.delaiRetourAvion ?? 0;
        this.repartitionAvantageuse = data?.repartitionAvantageuse ?? false;
        this.ouvertureDroits = data?.ouvertureDroits ?? false;
    }
}

export class PourcentageDomaine {
    /**Identifiant du domaine*/
    idDomaine: number;

    /**Libellé du domaine*/
    libelleDomaine: string;

    /**Pourcentage*/
    pourcentage: number;

    constructor(data?: Partial<PourcentageDomaine>) {
        this.idDomaine = data?.idDomaine ?? 0;
        this.libelleDomaine = data?.libelleDomaine ?? '';
        this.pourcentage = data?.pourcentage ?? 0;
    }
}

export class IndemnitesParametres {
    /**Configuration des délais*/
    reglesConf: ReglesAttributionConf;

    /**Liste des pourcentages par domaine*/
    listePourcentages: PourcentageDomaine[];

    constructor() {
        this.reglesConf = new ReglesAttributionConf();
        this.listePourcentages = [];
    }
}
